// extracted by mini-css-extract-plugin
export var text = "pagetitle-module--text--2koq_";